import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const ArrowDownFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M10.96 4.92H13.04V16.94L18.28 11.64L19.56 12.92L12 20.48L4.44 12.92L5.72 11.64L10.96 16.94V4.92Z" />
    </SvgIcon>
  );
});
